import { render, staticRenderFns } from "./hisAddPatient.vue?vue&type=template&id=38f3545a&scoped=true"
import script from "./hisAddPatient.vue?vue&type=script&lang=js"
export * from "./hisAddPatient.vue?vue&type=script&lang=js"
import style0 from "./hisAddPatient.vue?vue&type=style&index=0&id=38f3545a&prod&lang=css"
import style1 from "./hisAddPatient.vue?vue&type=style&index=1&id=38f3545a&prod&scoped=true&lang=css"
import style2 from "./hisAddPatient.vue?vue&type=style&index=2&id=38f3545a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3545a",
  null
  
)

export default component.exports